import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon, MagnifyingGlassIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid';

interface DraftListingViewProps {
  propertyId: string | number;
  propertyOwnerUid: string;
  currentUserId?: string;
}

const DraftListingView: React.FC<DraftListingViewProps> = ({
  propertyId,
  propertyOwnerUid,
  currentUserId,
}) => {
  const navigate = useNavigate();
  const isOwner = currentUserId === propertyOwnerUid;

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <HomeIcon className="w-24 h-24 text-amber-300" />
              <div className="absolute -bottom-2 -right-2 bg-amber-100 rounded-full p-2">
                <ExclamationCircleIcon className="w-8 h-8 text-amber-600" />
              </div>
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Draft Listing</h1>

          <p className="text-lg text-gray-600 mb-2">
            This property listing is still in draft status.
          </p>
          <p className="text-gray-500 mb-8">
            It hasn't been published yet and is not visible to the public.
          </p>

          {isOwner && (
            <div className="bg-amber-50 rounded-lg p-6 mb-8 border-2 border-amber-200">
              <p className="text-amber-800 font-semibold mb-4">
                This is your draft listing. Complete and publish it to make it visible.
              </p>
              <button
                onClick={() => navigate(`/edit-listing/${propertyId}`)}
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-amber-600 text-white font-semibold rounded-lg hover:bg-amber-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                Complete & Publish Listing
              </button>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/browse')}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              <MagnifyingGlassIcon className="w-5 h-5" />
              Browse Active Listings
            </button>

            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-300"
            >
              <HomeIcon className="w-5 h-5" />
              Go to Homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DraftListingView;
